export default "__VITE_ASSET__DSGJ3nPH__"